import React, { useEffect, useState } from "react";
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  Spinner, 
  Badge, 
  ListGroup, 
  Accordion, 
  Form, 
  Button, 
  Dropdown, 
  Modal
} from "react-bootstrap";
import { createClient } from "@supabase/supabase-js";

// Client Supabase
const supabase = createClient(
  "https://xecpjoetpimjupcoetmp.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhlY3Bqb2V0cGltanVwY29ldG1wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1MDg4MDIsImV4cCI6MjA2NjA4NDgwMn0.l3mHF5-IsZlYB4LawylJXw3JSgWp2rzIw5GkTlxRRoU"
);

const ClientsPage = () => {
  // Toată logica (useState, useEffect, funcțiile) este corectă și rămâne neschimbată
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newClientData, setNewClientData] = useState({ name: "", email: "", phone: "", contact_person: "" });
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingClient, setEditingClient] = useState(null);

  useEffect(() => { fetchClientsAndWebsites(); }, []);
  const fetchClientsAndWebsites = async () => {
    setLoading(true);
    const { data: clientsData, error: clientsError } = await supabase.from("clients").select("*").order('name', { ascending: true });
    if (clientsError) console.error("Eroare la preluarea clienților:", clientsError);
    const { data: websitesData, error: websitesError } = await supabase.from("websites").select("*");
    if (websitesError) console.error("Eroare la preluarea website-urilor:", websitesError);
    if (!clientsError && !websitesError) {
      const clientsWithWebsites = clientsData.map(client => ({
        ...client,
        websites: websitesData.filter(website => website.owner === client.name)
      }));
      setClients(clientsWithWebsites);
    }
    setLoading(false);
  };
  const handleNewClientChange = (e) => {
    const { name, value } = e.target;
    setNewClientData(prev => ({ ...prev, [name]: value }));
  };
  const handleNewClientSubmit = async (e) => {
    e.preventDefault();
    if (!newClientData.name) { alert("Numele clientului este obligatoriu."); return; }
    const { data, error } = await supabase.from("clients").insert([newClientData]).select();
    if (!error && data) {
      await fetchClientsAndWebsites();
      setNewClientData({ name: "", email: "", phone: "", contact_person: "" });
    } else {
      console.error("Eroare la adăugarea clientului:", error);
      alert(`Eroare: ${error.message}`);
    }
  };
  const handleDelete = async (client) => {
    if (client.websites && client.websites.length > 0) {
      alert(`Acest client nu poate fi șters deoarece are ${client.websites.length} site-uri asociate. Vă rugăm să schimbați proprietarul acelor site-uri mai întâi.`);
      return;
    }
    if (window.confirm(`Ești sigur că vrei să ștergi clientul "${client.name}"?`)) {
      const { error } = await supabase.from("clients").delete().match({ id: client.id });
      if (!error) { await fetchClientsAndWebsites(); } 
      else { console.error("Eroare la ștergerea clientului:", error); }
    }
  };
  const handleEditClick = (client) => {
    setEditingClient({ ...client, originalName: client.name });
    setShowEditModal(true);
  };
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingClient(prev => ({ ...prev, [name]: value }));
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    const { id, originalName, websites, ...updateData } = editingClient;
    const { error: updateClientError } = await supabase.from("clients").update(updateData).match({ id });
    if (updateClientError) {
      console.error("Eroare la actualizarea clientului:", updateClientError);
      alert(`Eroare: ${updateClientError.message}`);
      return;
    }
    if (updateData.name !== originalName) {
      const { error: updateWebsitesError } = await supabase.from("websites").update({ owner: updateData.name }).match({ owner: originalName });
      if (updateWebsitesError) { console.error("Eroare la actualizarea site-urilor:", updateWebsitesError); alert("Datele clientului au fost actualizate, dar a apărut o eroare la actualizarea site-urilor asociate."); }
    }
    setShowEditModal(false);
    await fetchClientsAndWebsites();
  };

  return (
    <Container className="py-4">
      <h3 className="mb-4 fw-bold">Management Clienți</h3>
      <Card className="p-4 mb-5 neumorphic-card">
        <h5>Adaugă Client Nou</h5>
        <Form onSubmit={handleNewClientSubmit}>
          <Row className="g-3">
            <Col md={6}><Form.Control name="name" placeholder="Nume Client / Companie*" value={newClientData.name} onChange={handleNewClientChange} required /></Col>
            <Col md={6}><Form.Control name="contact_person" placeholder="Persoană de contact" value={newClientData.contact_person} onChange={handleNewClientChange} /></Col>
            <Col md={6}><Form.Control type="email" name="email" placeholder="Email" value={newClientData.email} onChange={handleNewClientChange} /></Col>
            <Col md={6}><Form.Control name="phone" placeholder="Telefon" value={newClientData.phone} onChange={handleNewClientChange} /></Col>
            <Col xs={12}><Button type="submit" variant="primary" className="w-100">Adaugă Client</Button></Col>
          </Row>
        </Form>
      </Card>

      <h4 className="mb-4">Listă Clienți</h4>
      {loading ? (
        <div className="text-center w-100"><Spinner animation="border" /></div>
      ) : (
        <Accordion> 
          {clients.map((client) => (
            // Revenim la structura simplă cu Accordion.Item
            // FIX 1: Am șters clasa "overflow-hidden" de aici
            <Accordion.Item eventKey={client.id.toString()} key={client.id} className="mb-3 neumorphic-card border-0">
              <Accordion.Header>
                {/* Folosim un div pentru a alinia conținutul */}
                <div className="d-flex justify-content-between align-items-center w-100">
                  <span>
                    <span className="fw-bold fs-5">{client.name}</span>
                    <Badge pill bg="secondary" className="ms-3">
                      {client.websites.length} {client.websites.length === 1 ? 'Site' : 'Site-uri'}
                    </Badge>
                  </span>
                  
                  {/* FIX 2: Wrapper `div` în jurul Dropdown-ului cu `stopPropagation` */}
                  <div className="pe-2" onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle variant="light" size="sm">⋮</Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item onClick={() => handleEditClick(client)}>Editează</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDelete(client)} className="text-danger">Șterge</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                </div>
              </Accordion.Header>
              <Accordion.Body>
                <h5>Detalii Client</h5>
                <p className="mb-1"><strong>Persoană de contact:</strong> {client.contact_person || 'N/A'}</p>
                <p className="mb-1"><strong>Email:</strong> <a href={`mailto:${client.email}`}>{client.email || 'N/A'}</a></p>
                <p className="mb-3"><strong>Telefon:</strong> <a href={`tel:${client.phone}`}>{client.phone || 'N/A'}</a></p>
                
                <h5 className="mt-4">Website-uri Administrate</h5>
                {client.websites.length > 0 ? (
                  <ListGroup variant="flush">
                    {client.websites.map(site => (
                      <ListGroup.Item key={site.id} className="d-flex justify-content-between align-items-center">
                        <div>
                          <a href={`http://${site.domain}`} target="_blank" rel="noopener noreferrer" className="fw-bold text-decoration-none">
                            {site.name}
                          </a>
                          <small className="text-muted d-block">{site.domain}</small>
                        </div>
                        <Badge bg="success">{site.uptime}% Uptime</Badge>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                ) : (
                  <p className="text-muted">Acest client nu are niciun website înregistrat.</p>
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      )}

      {/* Modalul de editare este complet și corect */}
      {editingClient && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Editează Client</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleUpdate}>
              <Form.Group className="mb-3">
                <Form.Label>Nume Client / Companie</Form.Label>
                <Form.Control name="name" value={editingClient.name} onChange={handleEditChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Persoană de contact</Form.Label>
                <Form.Control name="contact_person" value={editingClient.contact_person || ""} onChange={handleEditChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={editingClient.email || ""} onChange={handleEditChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Telefon</Form.Label>
                <Form.Control name="phone" value={editingClient.phone || ""} onChange={handleEditChange} />
              </Form.Group>
              <Button variant="secondary" onClick={() => setShowEditModal(false)} className="me-2">Anulează</Button>
              <Button variant="primary" type="submit">Salvează Modificările</Button>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </Container>
  );
};

export default ClientsPage;
